import { useSelector, useDispatch } from 'react-redux';
import { setHasCustomLink, setData } from './customLinks.slice';

export default function useCustomLinkActions() {
  const customLink = useSelector((state) => state.customLinks);

  const dispatch = useDispatch();

  const eneableEventWithCustomLink = () => {
    dispatch(setHasCustomLink(true));
  };

  const disableEventWithCustomLink = () => {
    dispatch(setHasCustomLink(false));
  };

  const setCustomLinkData = (data) => {
    const { use, status, link } = data;
    dispatch(
      setData({
        hasCustomLink: use,
        linkStatus: status,
        link,
      }),
    );
  };

  return {
    customLink,
    eneableEventWithCustomLink,
    disableEventWithCustomLink,
    setCustomLinkData,
  };
}
